export default __webpack_public_path__ + "static/media/image-board-study-pyramid-n-w.ea8fd674.png";